import React, {Component} from 'react';
import {connect} from 'react-redux'

import HomepageLayout from '../../components/Homepage/index'
import Footer from '../../components/Footer'

class Default extends Component {



    render() {
        return (
            <HomepageLayout>
                {this.props.children}
                <Footer />
            </HomepageLayout>
        );
    }
}


const mapStateToProps = state => ({

});


function mergeProps(stateProps, dispatchProps, ownProps) {
    return {

        ...stateProps,
        ...ownProps,
        ...dispatchProps,

    }
}

export default connect(
    mapStateToProps,
    null,
    mergeProps
)(Default)


// WEBPACK FOOTER //
// ./src/scenes/Default/index.js